import { RouteObject } from "react-router-dom";
import { AllTokens } from "gql/graphql";
import { Guard } from "@/shared/security/model/guard/guard";
import { RequestAbsence, REQUESTS_ABSENCE_PATH } from "./requests-absence";
import {
  RequestAbsenceForm,
  REQUESTS_ABSENCE_CREATE_PATH,
  REQUESTS_ABSENCE_EDIT_PATH,
} from "./requests-absence-form";
import { REQUESTS_PATH, RequestsPage } from "@/modules/requests/pages/requests";
import { DYNAMIC_REQUESTS_PATH, DynamicRequestsPage } from "./dynamic-requests";
import {
  DYNAMIC_REQUEST_CREATE_PATH,
  DYNAMIC_REQUEST_EDIT_PATH,
  DynamicRequestPage,
} from "./dynamic-request";
import {
  REQUESTS_BUSINESS_TRIP_PATH,
  BusinessTripRequestsPage,
} from "./business-trip-requests";
import {
  BusinessTripRequestPage,
  REQUEST_BUSINESS_TRIP_CREATE_PATH,
  REQUEST_BUSINESS_TRIP_EDIT_PATH,
} from "./business-trip-request";
import { REQUEST_REGISTRY_PATH, RequestRegistryPage } from "./request-registry";
import {
  RESIGNATION_REQUESTS_PATH,
  ResignationRequestsPage,
} from "@/modules/requests/pages/resignation-requests";
import {
  RESIGNATION_REQUEST_PATH,
  ResignationRequestPage,
} from "@/modules/requests/pages/resignation-request";
import {
  WEEKEND_WORK_REQUESTS_PATH,
  WeekendWorkRequestsPage,
} from "@/modules/requests/pages/weekend-work-requests";
import {
  WeekendWorkRequestPage,
  REQUEST_WEEKEND_WORK_CREATE_PATH,
  REQUEST_WEEKEND_WORK_EDIT_PATH,
} from "@/modules/requests/pages/weekend-work-request";
import {
  COMPENSATORY_TIME_OFF_REQUESTS_PATH,
  CompensatoryTimeOffRequestsPage,
} from "@/modules/requests/pages/compensatory-time-off-requests";
import {
  CompensatoryTimeOffRequestPage,
  REQUEST_COMPENSATORY_TIME_OFF_CREATE_PATH,
  REQUEST_COMPENSATORY_TIME_OFF_EDIT_PATH,
} from "@/modules/requests/pages/compensatory-time-off-request";
import {
  WORK_CONDITIONS_CHANGE_REQUESTS_PATH,
  WorkConditionsChangeRequestsPage,
} from "@/modules/requests/pages/work-conditions-change-requests";
import {
  WORK_CONDITIONS_CHANGE_REQUEST_PATH,
  WorkConditionsChangeRequestPage,
} from "@/modules/requests/pages/work-conditions-change-request";

export const requestsRoutes: RouteObject[] = [
  {
    path: REQUESTS_PATH,
    element: <RequestsPage />,
  },
  {
    path: REQUESTS_ABSENCE_PATH,
    element: <RequestAbsence />,
  },
  {
    path: REQUESTS_ABSENCE_CREATE_PATH,
    element: <RequestAbsenceForm />,
  },
  {
    path: REQUESTS_ABSENCE_EDIT_PATH,
    element: <RequestAbsenceForm />,
  },
  {
    path: DYNAMIC_REQUESTS_PATH,
    element: <DynamicRequestsPage />,
  },
  {
    path: DYNAMIC_REQUEST_CREATE_PATH,
    element: <DynamicRequestPage />,
  },
  {
    path: DYNAMIC_REQUEST_EDIT_PATH,
    element: <DynamicRequestPage />,
  },
  {
    path: REQUESTS_BUSINESS_TRIP_PATH,
    element: <BusinessTripRequestsPage />,
  },
  {
    path: REQUEST_BUSINESS_TRIP_CREATE_PATH,
    element: <BusinessTripRequestPage />,
  },
  {
    path: REQUEST_BUSINESS_TRIP_EDIT_PATH,
    element: <BusinessTripRequestPage />,
  },
  {
    path: REQUEST_REGISTRY_PATH,
    element: (
      <Guard.Redirect.IfCantModify.PageNotFound
        influencedBy={[AllTokens.TasksApprovingRegister]}
      >
        <RequestRegistryPage />
      </Guard.Redirect.IfCantModify.PageNotFound>
    ),
  },
  {
    path: RESIGNATION_REQUESTS_PATH,
    element: <ResignationRequestsPage />,
  },
  {
    path: RESIGNATION_REQUEST_PATH,
    element: <ResignationRequestPage />,
  },
  {
    path: WEEKEND_WORK_REQUESTS_PATH,
    element: <WeekendWorkRequestsPage />,
  },
  {
    path: REQUEST_WEEKEND_WORK_CREATE_PATH,
    element: <WeekendWorkRequestPage />,
  },
  {
    path: REQUEST_WEEKEND_WORK_EDIT_PATH,
    element: <WeekendWorkRequestPage />,
  },
  {
    path: COMPENSATORY_TIME_OFF_REQUESTS_PATH,
    element: <CompensatoryTimeOffRequestsPage />,
  },
  {
    path: REQUEST_COMPENSATORY_TIME_OFF_CREATE_PATH,
    element: <CompensatoryTimeOffRequestPage />,
  },
  {
    path: REQUEST_COMPENSATORY_TIME_OFF_EDIT_PATH,
    element: <CompensatoryTimeOffRequestPage />,
  },
  {
    path: WORK_CONDITIONS_CHANGE_REQUESTS_PATH,
    element: <WorkConditionsChangeRequestsPage />,
  },
  {
    path: WORK_CONDITIONS_CHANGE_REQUEST_PATH,
    element: <WorkConditionsChangeRequestPage />,
  },
];
